<template>
  <div>
    <kn-form-subtitle :title="`${actionTitle} banco`" />
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-row>
        <v-col 
          class="pb-0" 
          cols="12"
          md="4"
          lg="4"
          xl="4">
          <v-subheader>Título:</v-subheader>
        </v-col>
        <v-col class="pb-0">
          <v-text-field
            v-model="bank.dato"
            dense
            outlined
            :rules="[rules.required]"
          />
        </v-col>
      </v-row>
      <kn-form-action-buttons
        class="mb-14"
        :small="true"
        :disableAccept="invalidFields"
        @accept="save"
        @cancel="clear"
      />
    </v-form>
    <kn-form-subtitle
      title="Listado de bancos"
      divider-position="bottom"
    />
    <kn-list-with-actions
      :activeItems="activeBanks"
      @updateInline="updateInline"
      @deleteInline="deleteInline"
      @cancelInline="clearInline"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { api } from '@/api/axios-base'
import { validationFormMixin } from '@/mixins/validationFormMixin'
export default {
  components: {
    KnFormSubtitle: () => import('@/components/KnFormSubtitle.vue'), 
    KnFormActionButtons: () => import('@/components/KnFormActionButtons.vue'),
    KnListWithActions: () => import('./KnListWithActions.vue')
  },
  mixins: [validationFormMixin],
  data() {
    return {
      errors: [],
      valid: true,
      bank: {
        id: 'NA', // No asignado
        dato: null,
        id_autor: null,
        id_institucion_educativa: null
      },
      banks: [],
      toUpdate: false
    }
  },
  computed: {
    ...mapState(['institutionId', 'userData']),
    actionTitle() {
      return this.toUpdate ? 'Actualizar' : 'Agregar'
    },
    activeBanks() {
      return this.banks.filter(st => st.estatus_sistema === true)
    },
    invalidFields() {
      return this.objectHasNulls(this.bank)
    }
  },
  async created() {
    this.bank.id_autor = this.userData.id
    this.bank.id_institucion_educativa = this.institutionId
    this.banks = await this.fetchBanksByEI(this.institutionId)

  },
  methods: {
    async fetchBanksByEI(institutionId) {
      try {
        const response = await api.get(`/administracion/api/banco-by-ie/?id_institucion=${institutionId}`)
        const responseData = await response.data
        return responseData
      } catch (error) {
        console.error('Error al intentar obtener banco por institucion educativa', error);
      }
    },
    async createBanks() {
      try {
        const response = await api.post('/administracion/crear-banco', {
          nombre_banco: this.bank.dato,
          id_autor: this.bank.id_autor,
          id_institucion_educativa: this.bank.id_institucion_educativa
        })
        const responseData = await response.data
        if (responseData.e) {
          this.errors.push('Ocurrió un error, no se pudo crear el banco.')
        }
      } catch (error) {
        console.error('Error al intentar crear banco', error)
        this.errors.push('Error al intentar crear banco')
      }
    },
    async updateBanks() {
      try {
        const response = await api.patch('/administracion/update-banco', {
          id: this.bank.id,
          banco: this.bank.dato,
          id_institucion_educativa: this.institutionId
        })
        const responseData = await response.data
        if (responseData.e) {
          this.errors.push('Ocurrió un error, no se pudo actualizar el banco')
        }
      } catch (error) {
        console.error('Error al intentar actualizar banco', error);
      }
    },
    // Los deletes no eliminan los registros, cambian el estatus a False
    async deleteBanks(typeId) {
      try {
        const response = await api.post('/administracion/delete-banco', {
          id_banco: typeId
        })
        const responseData = await response.data
        if (responseData.e) {
          this.errors.push('Ocurrió un error, no se pudo eliminar el banco')
        }
      } catch (error) {
        console.error('Error al intentar eliminar banco', error);
      }
    },
    async save() {
      await this.createBanks()
      this.banks = await this.fetchBanksByEI(this.institutionId)
      this.clear()
    },
    clear() {
      this.bank = {
        id: 'NA', // No asignado
        dato: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId 
      }
      this.toUpdate = false
      this.$refs.form.resetValidation()
    },
    clearInline() {
      this.bank = {
        id: 'NA', // No asignado
        dato: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId 
      }
      this.toUpdate = false
      this.$refs.form.resetValidation()
    },
    async updateInline(item) {
      // console.log('updateInline item', item);
      this.bank = {...item}
      await this.updateBanks()
      this.banks = await this.fetchBanksByEI(this.institutionId)
      this.clearInline()
    },
    async deleteInline(itemId) {
      await this.deleteBanks(itemId)
      this.banks = await this.fetchBanksByEI(this.institutionId)
      this.clearInline()
    }
  },
}
</script>

<style>

</style>